import { useContext } from "react";
import { configStore } from "../../../contexts/ConfigContext";
import type { Pagetype } from "../../../interfaces/Config";

const useWorkModeEntryLearningSetIds = (pageType: Pagetype): string[] => {
  const {
    config: { pages },
  } = useContext(configStore);
  return (
    pages.find((page) => page.type === pageType)?.entryLearningSetIds ?? []
  );
};
export default useWorkModeEntryLearningSetIds;
